module.exports = __webpack_public_path__ + "static/media/profile-image-placeholder.35810fb4.svg";